export type MetriceConfig = {
  indicator: string;
  unit: string;
};

export const DefaultBarColor = "#2595CF";

export const metriceConfig: MetriceConfig[] = [
  { indicator: "EPS", unit: "" },
  { indicator: "PE Ratio", unit: "" },
  { indicator: "Forward PE", unit: "" },
  { indicator: "PS Ratio", unit: "" },
  { indicator: "PB Ratio", unit: "" },
  { indicator: "Price-to-FCF", unit: "" },
  {
    indicator: "Gross Margin",

    unit: "%",
  },
  { indicator: "Net Margin", unit: "%" },
  {
    indicator: "Revenue Growth (YoY)",
    unit: "%",
  },
  {
    indicator: "Profit Growth (YoY)",
    unit: "%",
  },
  {
    indicator: "3-Year Revenue Growth",
    unit: "%",
  },
  {
    indicator: "3-Year Profit Growth",
    unit: "%",
  },
];

export const BarColorMap = {
  low: "#EF4444",
  mid: "#2595CF",
  high: "#22C55D",
};
